import React, { Component } from 'react'
import {
  Modal,
  ModalBackground,
  Delete,
  ModalCard,
  ModalCardBody,
  ModalCardFooter,
  ModalCardHeader,
  ModalCardTitle,
  Button,
  Field, Control, Input, Label, Help,
  Notification, Icon
} from 'bloomer'
import { Mutation } from 'react-apollo'
import { gql } from 'apollo-boost'

const ADD_MEMBER_TO_HOUSE = gql`
  mutation ($email: String!, $houseId: UUID!) {
    addHouseMember(email: $email, houseId: $houseId) {
      invitation { id }
    }
  }
`

const initialState = {
  email: '',
  error: null,
  success: false
}

export default class AddRoomModal extends Component {
  state = {
    ...initialState
  }

  handleChange = (key) => (evt) => {
    const value = evt.target.value
    this.setState(() => ({[key]: value}))
  }

  handleClose = (evt) => {
    this.setState(() => ({
      ...initialState
    }))

    this.props.handleClose(evt)
  }

  handleSubmit = async (mutate, evt) => {
    evt.preventDefault()

    const { email } = this.state

    if (email === '') {
      this.setState(() => ({
        error: 'Informe o email para enviar o convite'
      }))
      return
    }

    try {
      await mutate()

      this.setState(() => ({
        success: true
      }))
    } catch (e) {
      this.setState(() => ({
        error: 'Não foi possível enviar o convite, tente novamente mais tarde'
      }))
      console.error(e)
    }
  }

  render() {
    const { email, error, success } = this.state
    const { isActive, houseId } = this.props

    return (
      <Modal isActive={isActive}>
        <ModalBackground onClick={this.handleClose}/>

        <Mutation mutation={ADD_MEMBER_TO_HOUSE} variables={{houseId, email}}>
          {(mutate, {loading}) => (
            <ModalCard tag="form" onSubmit={this.handleSubmit.bind(this, mutate)}>
              <ModalCardHeader>
                <ModalCardTitle>Adicionar membro</ModalCardTitle>
                <Delete onClick={this.handleClose} />
              </ModalCardHeader>
              <ModalCardBody style={{padding: success && 0}}>
                {success ? (
                  <Notification isColor="success" style={{textAlign: 'center'}}>
                    <Icon className="fa fa-check-circle fa-2x" isSize="medium" />
                    <p>Convite enviado.</p>
                  </Notification>
                ) : (
                  <Field>
                    <Control>
                      <Label>Email</Label>
                      <Input type="email" placeholder="meu.amigo@mail.com" isColor={error ? 'danger' : null} autoFocus onChange={this.handleChange('email').bind(this)} value={email} />
                      {error && <Help isColor="danger">{error}</Help>}
                    </Control>
                  </Field>
                )}

              </ModalCardBody>
              <ModalCardFooter>
                {!success && <Button type="submit" isLoading={loading} isColor="success">Convidar</Button>}
                <Button onClick={this.handleClose}>{success ? 'Fechar' : 'Cancelar'}</Button>
              </ModalCardFooter>
            </ModalCard>
          )}
        </Mutation>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/DashboardPage/modals/AddMemberModal.js